
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'

import { Post } from '@/models'

export default {
name: 'commentPostPopup',
created() {
},
props: ['value', 'post', 'targetComment'],
data() {
return {
comment: ""
}
},
computed: {
targetUsername: function() {
if (this.targetComment) {
return "@" + this.targetComment.user.username
} else {
return null
}
}
},
methods: {
onShow: function() {



},

submit: function() {
let comment = (this.comment || "").trim()

if (!comment) {
return
}

Post.comment(this.post.objectId, comment, this.targetComment).then((comment) => {
this.$emit('submit', comment)
this.comment = ""
})
},

close: function() {
this.$emit('input', false)
}
},
components: {
Popup,
XButton,
XTextarea,
Group
}
}



// WEBPACK FOOTER //
// ./src/components/CommentPostPopup.vue